import angular from 'npm/angular';
import _ from 'npm/lodash';

import Auth from 'common/auth/auth';
import InventoryHierarchy from 'common/inventory/inventory.hierarchy';
import OrderStore from 'common/stores/orderStore';
import CustomerStore from 'common/stores/customerStore';
import Utilities from 'common/utils/utils';
import Config from 'common/config';

import PkLoader from 'common/pk.loader.component/pk.loader.component';
import PkFloater from 'common/pk.floater/pk.floater';
import Payment from '../components/payment/payment.controller.js';

import iconCache from 'common/inventory/inventory.icons';

import register from 'common/register';

window.moment = require('npm/moment/moment.js');

let commonModule = angular.module('app.common', []);

register('app.common')
    .service('inventory', InventoryHierarchy)
    .service('orderStore', OrderStore)
    .service('utils', Utilities)
    .service('config', Config)
    .service('auth', Auth)
    .service('payment', Payment)
    .factory('iconCache', iconCache)
    .directive('pkLoader', PkLoader)
    .directive('pkFloater', PkFloater);


export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js